import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import * as log from '@/model/util/log/Logger'
import Baseinput from '@/components/common/input/BaseInput.vue'
import { toInputType } from './inputType'


import { defineComponent, computed } from 'vue'

const __default__ = defineComponent({
  inheritAttrs: false,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BasePassword',
  props: {
  // データ
  modelValue: {
    type: String,
    default: '',
  },
  // placeholder
  placeholder: {
    type: String,
    default: undefined,
  },
  // 最大サイズ
  maxlength: {
    type: Number,
    default: 32,
  },
  // autofocus属性
  autofocus: {
    type: Boolean,
    default: undefined,
  },
  // autocomplete属性
  autocomplete: {
    type: String,
    default: undefined,
  },
  // inputmode属性 html5.2で廃止されたがHTML Living Standardで復活した
  inputmode: {
    type: String,
    default: undefined,
  },
  // パスワード表示状態
  passwordStatus: {
    type: Boolean,
    default: true,
  },
  // 初期状態のフォーカス
  initFocus: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "input-password-enter", "input-text-enter"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string): void
  (e: 'input-password-enter'): void
  (e: 'input-text-enter'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

log.trace(`BasePassword setup start.`)
// プロパティ定義


// Emit定義


/**
 * inputmodeの取得
 */
const inputmode = toInputType(props.inputmode)

/**
 * テキストデータ算出プロパティ
 */
const textValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

/**
 * パスワード入力ボックスenter押下イベント
 */
const onPasswordEnter = () => {
  log.trace(`BasePassword onPasswordEnter start.`)
  emit('input-password-enter')
  log.trace(`BasePassword onPasswordEnter end.`)
}

/**
 * テキスト入力ボックスenter押下イベント
 */
const onTextEnter = () => {
  log.trace(`BasePassword onTextEnter start.`)
  emit('input-text-enter')
  log.trace(`BasePassword onTextEnter end.`)
}

log.trace(`BasePassword setup end.`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(Baseinput, {
      type: "password",
      maxlength: props.maxlength,
      styles: "mxa-password-text",
      placeholder: props.placeholder,
      modelValue: _unref(textValue),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(textValue) ? (textValue).value = $event : null)),
      autocomplete: props.autocomplete,
      autofocus: props.autofocus,
      inputmode: _unref(inputmode),
      "init-focus": props.initFocus,
      "data-test": "input_password",
      onInputEnter: onPasswordEnter
    }, null, 8, ["maxlength", "placeholder", "modelValue", "autocomplete", "autofocus", "inputmode", "init-focus"]), [
      [_vShow, props.passwordStatus]
    ]),
    _withDirectives(_createVNode(Baseinput, {
      type: "text",
      maxlength: props.maxlength,
      styles: "mxa-password-text",
      placeholder: props.placeholder,
      modelValue: _unref(textValue),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(textValue) ? (textValue).value = $event : null)),
      autocomplete: props.autocomplete,
      inputmode: _unref(inputmode),
      "init-focus": false,
      "data-test": "input_text",
      onInputEnter: onTextEnter
    }, null, 8, ["maxlength", "placeholder", "modelValue", "autocomplete", "inputmode"]), [
      [_vShow, !props.passwordStatus]
    ])
  ], 64))
}
}

})